import { defineStore } from "pinia";
import { UserAPI } from "@/api";
import { useSocketStore } from "@/store/socket";
import router from "@/router";

export const useConfigStore = defineStore("config", {
  state: () => ({
    user: "",
    token: "",
    matomoVisitorId: "", //matomo visitorID
    userLocation: "", // "lobby" , "table"
    tableId: "",
    casinoId: "",
    currentStream: 4, // 預設直播線路 No.4 *從1開始
    shoeId: "",
    tableType: "",
    userStatus: "inactive", // 用戶狀態 "active", "inactive", "kickOff", "LoggedIn","tokenExpired","notExist"
    version: import.meta.env.VITE_GIT_VERSION,
  }),
  getters: {
    getToken: (state) => state.token,
    getUser: (state) => state.user,
    getLocation: (state) => state.location,
    getTableId: (state) => state.tableId,
    getVersion: (state) => state.version,
  },
  actions: {
    setState(key, value) {
      if (typeof key === "object") {
        Object.assign(this, key);
      } else {
        this[key] = value;
      }
    },
    generateChars(length = 6) {
      const chars = "abcdefghijklmnopqrstuvwxy0123456789";
      let id = "";
      for (let i = 0; i < length; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    getStreamNumber(index) {
      return index + 1 + (index >= 3 ? 1 : 0);
    },
    async login(userNumber) {
      const socketStore = useSocketStore();
      try {
        const res = await UserAPI.login(userNumber);
        if (res.status === "0000") {
          // socket connect
          console.log(
            "狀態",
            socketStore.getIsConnected,
            import.meta.env.VITE_SOCKET_URL,
            userNumber,
          );
          if (!socketStore.getIsConnected) {
            await socketStore.connect(
              import.meta.env.VITE_SOCKET_URL || window.CONFIG.WS,
            );
            await socketStore.waitForConnect();
          }
          this.user = userNumber;
          this.token = res.data.token;
          this.tableId = res.data.table_id;
          this.casinoId = res.data.casino_id;
          socketStore.emit("login", {
            token: this.token,
            visitor_id: this.matomoVisitorId,
          });
          this.userStatus = "active";
          return "success";
        } else {
          console.warn("Login failed:", res.message);
          return res.message;
        }
      } catch (e) {
        return e.message;
      }
    },
    async logout() {
      const socketStore = useSocketStore();
      if (this.userStatus != "kickOff") {
        this.userStatus = "inactive";
        socketStore.emit("clientLogout", this.token);
      }
      try {
        const res = await UserAPI.logout();
        if (res.status === "0000") {
          this.token = this.tableId = this.shoeId = this.casinoId = "";
          sessionStorage.removeItem("config");
          this.userLocation = "lobby";
          return "success";
        }
        return "fail";
      } catch (e) {
        return e.message;
      } finally {
        this.token = "";
        console.log("logout:", socketStore.getIsConnected);
        if (socketStore.getIsConnected) {
          console.log("logout");
          socketStore.disconnect();
        }
        router.push(`/login`);
      }
    },
  },
  // 使用 omit 排除不需要的欄位
  persist: {
    key: "config",
    storage: localStorage,
    omit: ["tableType", "version"],
  },
});
